import { useState, useEffect } from 'react';
import { Bell, X } from 'lucide-react';
import { isPushNotificationSupported, isSubscribedToPushNotifications, subscribeToPushNotifications } from '../lib/notifications';

export function NotificationBanner() {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    checkStatus();
  }, []);

  const checkStatus = async () => {
    const supported = await isPushNotificationSupported();
    if (!supported) return;

    const subscribed = await isSubscribedToPushNotifications();
    if (!subscribed) {
      const dismissed = localStorage.getItem('notification-banner-dismissed');
      if (!dismissed) {
        setShow(true);
      }
    }
  };

  const handleEnable = async () => {
    setLoading(true);
    try {
      const success = await subscribeToPushNotifications();
      if (success) {
        setShow(false);
      } else {
        alert('Failed to enable notifications. Please check your browser settings.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleDismiss = () => {
    setShow(false);
    localStorage.setItem('notification-banner-dismissed', 'true');
  };

  if (!show) return null;

  return (
    <div className="bg-blue-600 text-white p-4 mb-4 rounded-lg shadow-lg">
      <div className="flex items-start gap-3">
        <Bell className="flex-shrink-0 mt-0.5" size={20} />
        <div className="flex-1">
          <p className="font-semibold mb-1">Enable Notifications</p>
          <p className="text-sm text-blue-100 mb-3">
            Get reminded when it's time to take your supplements. Never miss a dose!
          </p>
          <div className="flex gap-2">
            <button
              onClick={handleEnable}
              disabled={loading}
              className="px-4 py-2 bg-white text-blue-600 rounded-lg font-medium hover:bg-blue-50 disabled:opacity-50 text-sm"
            >
              {loading ? 'Enabling...' : 'Enable Now'}
            </button>
            <button
              onClick={handleDismiss}
              className="px-4 py-2 bg-blue-700 text-white rounded-lg font-medium hover:bg-blue-800 text-sm"
            >
              Maybe Later
            </button>
          </div>
        </div>
        <button
          onClick={handleDismiss}
          className="text-blue-100 hover:text-white"
        >
          <X size={20} />
        </button>
      </div>
    </div>
  );
}
